import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getContext } from '../../redux/spaces-slice';
const BRANDING_URL_PATH_MARKER = '/signage/logos';
const resolveBrandingUrl = (brandingUrl) => {
    if (!brandingUrl) {
        return undefined;
    }
    const markerIndex = brandingUrl.indexOf(BRANDING_URL_PATH_MARKER);
    if (markerIndex === -1 || typeof window === 'undefined') {
        return brandingUrl;
    }
    return `${window.origin}${brandingUrl.slice(markerIndex)}`;
};
const BrandingContainer = styled.div `
  display: flex;
  align-items: center;
  height: 4.63vh;
  min-width: fit-content;
  max-width: 10vw;
  max-height: 4.63vh;
  width: fit-content;
  border-radius: 0.833vw;
  background-color: #1f2226;
  padding: 1.302vw;
`;
const Logo = styled.img `
  display: block;
  max-height: 4.444vh;
  min-width: 6vw;
`;
export default function BrandLogo() {
    const context = useSelector(getContext);
    const brandingUrl = resolveBrandingUrl(context.brandingUrl) ||
        require('../../../../assets/images/cisco_brand_logo.svg');
    return (_jsx(BrandingContainer, { children: _jsx(Logo, { src: brandingUrl, alt: "Brand Logo" }) }));
}
